import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cn, getPostTypeString } from '../../../../../utils';
import { checkIsAuthenticated } from '../../../../../utils/authUtils';
import { SEARCH_PAGE_LINK } from '../../../../../utils/routes';
import useLoginRoute from '../../../../hooks/useLoginRoute';
import { setLoginFirstModalOpen } from '../../../../store/slices/common/commonSlice';
import { getTopNotificationsAsync } from '../../../../store/slices/common/notificationsSlice';
import LoginFirstModal from '../../../Common/LoginFirstModal/LoginFirstModal';
import MuiDrawer from '../../../Common/MUIDrawer/MUIDrawer';
import RedDot from '../../../Common/RedDot';
import {
  MdChatBubbleOutline,
  MdClose,
  MdOutlineArrowRightAlt,
  MdOutlineMenu,
  MdOutlineSearch,
  MdPersonOutline,
} from '../../../CustomSVG/MaterialIcons';
import SearchFieldWithoutSuggestions from '../../../Market/SearchField/SearchFieldWithoutSuggestions';
import SearchSuggestions from '../../../Market/SearchField/SearchSuggestions';
import AvatarButton from '../../AvatarButton';
import FlyoutMenuContent from '../../FlyoutMenu/FlyoutMenuContent';
import Notifications from '../../Notifications';
import ChatMenuContent from '../ChatMenuContent';
import BottomNavMenu from './BottomNavMenu';
import NewsTicker from '../../../Common/NewsTicker';
import useMobileDetect from '../../../../hooks/useMobileDetect';

export default function BottomNav({
  userDetails,
  isAuthenticated = false,
  openNotificationMenu,
  setOpenNotificationMenu,
}) {
  const dispatch = useDispatch();
  const isMobile = useMobileDetect();
  const [showChatComponent, setShowChatComponent] = useState(false);
  const router = useRouter();
  const { city } = router.query;
  const { loginRoute } = useLoginRoute();
  const [open, setOpen] = useState({
    menu: false,
    search: false,
    plus: false,
    chat: false,
    account: false,
  });

  const lang = useSelector(({ common }) => common?.language);
  const moduleName = getPostTypeString(router.pathname);
  const [searchText, setSearchText] = useState(null);
  const [selectedPostType, setSelectedPostType] = useState(null);
  const [value, setValue] = useState('recents');
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const searchSuggestions = useSelector(({ market }) => {
    return market?.searchSuggestions;
  });

  const topNotifications = useSelector(
    ({ notifications }) => notifications?.topNotifications
  );

  // const unreadNotifications = useSelector(
  //   ({ notifications }) => notifications?.unreadNotifications
  // );

  const unreadChatExists = useSelector(
    ({ notifications }) => notifications?.unreadChatExists
  );

  const breakingNews = useSelector(({ common }) => common?.breakingNews);

  const showNewsTicker = () => {
    if (isMobile && router.pathname !== '/') {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    topNotifications?.forEach((notification) => {
      if (!notification.read_at)
        setUnreadNotificationCount((count) => count + 1);
    });
  }, [topNotifications]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (isAuthenticated && topNotifications && topNotifications?.length === 0) {
      // dispatch(getProfileDataAsync());
      dispatch(getTopNotificationsAsync());
    }
  }, [isAuthenticated]);
  const handleChatForGuestUser = () => {
    if (!checkIsAuthenticated()) {
      dispatch(setLoginFirstModalOpen(true));
    }
  };
  const handleStartNewDiscussionClick = () => {
    if (!checkIsAuthenticated()) {
      dispatch(setLoginFirstModalOpen(true));
    } else {
      router.push('/community/start-discussion');
    }
  };
  const handlePlaceAdClick = () => {
    if (!checkIsAuthenticated()) {
      dispatch(setLoginFirstModalOpen(true));
    } else {
      router.push('/market/place-ad');
    }
  };
  return (
    <div
      className={cn(
        'fixed z-[1500] h-[64px]   w-full rounded-t-md border-t-[1px] bg-white shadow-xl md:hidden',
        breakingNews ? 'bottom-10' : 'bottom-0'
      )}
    >
      <BottomNavigation
        showLabels={false}
        sx={{ width: '100%', height: '100%', color: '#000', padding: '0 16px' }}
        value={value}
        onChange={handleChange}
      >
        <BottomNavigationAction
          onClick={() =>
            setOpen({
              ...open,
              menu: !open.menu,
            })
          }
          sx={{
            color: '#000',
            padding: 0,
            minWidth: 0,
            '& .Mui-selected': {
              color: '#000',
            },
          }}
          // label="Recents"
          value='menu'
          icon={<MdOutlineMenu className='text-[24px] font-bold' />}
        />
        <BottomNavigationAction
          onClick={() => {
            setOpen({
              ...open,
              search: !open.search,
            });
          }}
          sx={{ padding: 0, minWidth: 0 }}
          showLabel={false}
          value='search'
          icon={<MdOutlineSearch className='text-[24px] font-bold' />}
        />

        <BottomNavigationAction
          onClick={() =>
            setOpen({
              ...open,
              plus: !open.plus,
            })
          }
          sx={{ padding: 0, minWidth: 0 }}
          value='plus'
          icon={
            <div className='flex !h-[48px] w-[48px] items-center justify-center rounded-full bg-[#000]'>
              <span className='text-[40px] font-bold text-white'>+</span>
            </div>
          }
        />
        {isAuthenticated ? (
          <BottomNavigationAction
            onClick={() => {
              if (router?.pathname !== '/chats') {
                setOpen({
                  ...open,
                  chat: !open.chat,
                });
              }
            }}
            sx={{ padding: 0, minWidth: 0 }}
            showLabel={false}
            value='chat'
            icon={
              <div className='relative h-[24px] w-[24px]'>
                <MdChatBubbleOutline />
                {unreadChatExists ? <RedDot /> : null}
              </div>
            }
          />
        ) : (
          <BottomNavigationAction
            sx={{ padding: 0, minWidth: 0 }}
            showLabel={false}
            value='chat'
            icon={
              <div className='relative h-[24px] w-[24px]'>
                <MdChatBubbleOutline />
              </div>
            }
            onClick={handleChatForGuestUser}
          />
        )}
        <BottomNavigationAction
          sx={{ padding: 0, minWidth: 0 }}
          showLabel={false}
          value='account'
          icon={
            <>
              {isAuthenticated ? (
                <div
                  onClick={() => {
                    setOpen({
                      ...open,
                      account: !open.account,
                    });
                  }}
                >
                  <AvatarButton
                    userName={userDetails?.name}
                    height='h-[32px]'
                    width='w-[32px]'
                  />
                </div>
              ) : (
                <div className='flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[#EDEDED]'>
                  <MdPersonOutline
                    onClick={() => {
                      router.push(loginRoute);
                    }}
                    className='text-[22px] font-bold'
                  />
                </div>
              )}
            </>
          }
        />
      </BottomNavigation>
      {open.menu ? (
        <BottomNavMenu
          open={open.menu}
          onCloseHandler={() => {
            setOpen({ ...open, menu: false });
          }}
        />
      ) : null}

      {open.search ? (
        <MuiDrawer
          open={open.search}
          onCloseHandler={() => {
            setOpen({ ...open, search: false });
          }}
        >
          <div className=' h-[80vh] w-full overflow-y-auto p-4'>
            <div className='mb-6 flex items-center justify-between border-b pb-4'>
              <h2 className='text-[18px] font-semibold'>{`Search in ${
                router?.pathname?.includes('/market')
                  ? 'Market'
                  : router?.pathname?.includes('/community')
                    ? 'Community'
                    : "Ron's Tips"
              }`}</h2>
              <MdClose
                onClick={() => {
                  setOpen({ ...open, search: false });
                }}
              />
            </div>

            <SearchFieldWithoutSuggestions
              closeSearchDrawer={() => {
                setOpen({ ...open, search: false });
              }}
              isMarket={router?.pathname?.includes('/market')}
              withoutPostType={!router?.pathname?.includes('/market')}
              searchText={searchText}
              setSearchText={setSearchText}
              selectedPostType={selectedPostType}
              setSelectedPostType={setSelectedPostType}
            />

            {searchSuggestions?.data?.length > 0 ? (
              <div className='mt-2'>
                <SearchSuggestions searchSuggestions={searchSuggestions} />
                <Link
                  href={SEARCH_PAGE_LINK({
                    moduleName,
                    postTypeId: selectedPostType?.id,
                    searchText,
                    city,
                  })}
                >
                  <button className='mx-auto mb-0 mt-4 flex items-center justify-center gap-1 rounded-[100px]  border-[1px] border-black px-[12px] py-2 font-bold text-black'>
                    {lang?.common?.see_all_results}
                    <MdOutlineArrowRightAlt className='mt-1 text-[22px] font-bold' />
                  </button>
                </Link>
              </div>
            ) : (
              searchSuggestions && (
                <p className='mb-0 flex justify-center bg-[#F6F6F6] px-[12px] py-2 font-bold'>
                  {lang?.common?.no_results_found}
                </p>
              )
            )}
          </div>
        </MuiDrawer>
      ) : null}

      {open.plus ? (
        <MuiDrawer
          open={open.plus}
          onCloseHandler={() => {
            setOpen({ ...open, plus: false });
          }}
        >
          <List>
            <ListItem>
              <ListItemButton onClick={handleStartNewDiscussionClick}>
                <p className='mb-0 text-[16px] font-bold'>
                  {lang?.common?.start_new_discussion}
                </p>
              </ListItemButton>
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemButton onClick={handlePlaceAdClick}>
                <p className='mb-0 text-[16px] font-bold'>
                  {lang?.market?.place_advertisement}
                </p>
              </ListItemButton>
            </ListItem>
          </List>
        </MuiDrawer>
      ) : null}
      {open.chat ? (
        <MuiDrawer
          open={open.chat}
          onCloseHandler={() => {
            setOpen({ ...open, chat: false });
          }}
        >
          <ChatMenuContent setShowChatComponent={setShowChatComponent} />
        </MuiDrawer>
      ) : null}
      {openNotificationMenu ? (
        <MuiDrawer
          open={openNotificationMenu}
          onCloseHandler={() => {
            setOpenNotificationMenu(false);
          }}
        >
          {/* <div className='flex h-[60vh] w-full justify-center'> */}
          <Notifications
            unreadNotificationCount={unreadNotificationCount}
            setUnreadNotificationCount={setUnreadNotificationCount}
            setOpen={setOpenNotificationMenu}
          />
          {/* </div> */}
        </MuiDrawer>
      ) : null}
      {open.account ? (
        <MuiDrawer
          open={open.account}
          onCloseHandler={() => {
            setOpen({ ...open, account: false });
          }}
        >
          <FlyoutMenuContent userDetails={userDetails} />
        </MuiDrawer>
      ) : null}

      <LoginFirstModal />
      {showNewsTicker() && <NewsTicker />}
    </div>
  );
}
